import { VDC2dRenderer } from "./renderer"

export function initVdc2d(wrapperId, vdcData, assets2d) {
  return new VDC2dRenderer(wrapperId, vdcData, assets2d)
}
